import type { GetRoadmaps200RoadmapsItemCreator } from './getRoadmaps200RoadmapsItemCreator';

export type GetRoadmaps200RoadmapsItem = {
  /** 로드맵에 포함된 강의 개수 */
  courseCount: number;
  /** 로드맵 생성 시각 */
  readonly createdAt: string;
  /** 로드맵 생성자 정보 */
  creator: GetRoadmaps200RoadmapsItemCreator;
  /**
   * 로드맵에 대한 간략한 설명
   * @nullable
   */
  description?: string | null;
  /** 로드맵 고유 ID (UUID) */
  id: string;
  /** 현재 사용자가 이 로드맵을 구독하고 있는지 여부 */
  isSubscribed: boolean;
  /** 로드맵 구독자 수 */
  subscriptionCount: number;
  /**
   * 로드맵 관련 태그 목록
   * @nullable
   */
  tags?: string[] | null;
  /** 로드맵 제목 */
  title: string;
  /** 로드맵 마지막 수정 시각 */
  readonly updatedAt: string;
};
